<template>
  <v-expansion-panels v-model="open">
    <v-expansion-panel>
      <v-expansion-panel-header style="font-size: 16px; font-weight: bold; color: #506d88">
        <img src="@/assets/LogoENE.png" class="exercise-icon" />
        {{ exerciseSet.exercise.title }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <div class="container-fluid">
          <v-row>
            <!-- Illustration -->
            <v-col cols="12" md="3" lg="4" xl="5" v-if="exerciseSet.exercise.preview || (medias && medias.length)">
              <label class="title-label">Illustration</label>

              <!-- Picture Preview -->
              <v-img v-if="exerciseSet.exercise.preview" :src="exerciseSet.exercise.preview"></v-img>
              <!-- Image -->
              <v-img
                v-else-if="medias[0] && (medias[0].image || medias[0].isImage) && !medias[0].src && !medias[0].videoOptions"
                style="height: auto; max-width: 100%; margin: 0"
                :src="medias[0].image"
              ></v-img>
              <!-- Video -->
              <video-player
                v-else-if="medias[0] && (medias[0].videoOptions || medias[0].youtube)"
                style="height: auto; width: 100%; margin: 0"
                :options="medias[0].videoOptions"
              ></video-player>
              <!-- IFrame -->
              <iframe v-else-if="medias[0] && medias[0].canal" style="height: auto; max-width: 100%; margin: 0" :src="medias[0].src"></iframe>
              <!-- Link -->
              <a v-else-if="medias[0] && medias[0].src" :href="medias[0].src" target="_blank">{{ medias[0].src }}</a>
            </v-col>
            <!-- Sets -->
            <v-col
              v-if="exerciseSet.set.length > 0"
              cols="12"
              :md="exerciseSet.exercise.preview || medias[0] ? 9 : 12"
              :lg="exerciseSet.exercise.preview || medias[0] ? 8 : 12"
              :xl="exerciseSet.exercise.preview || medias[0] ? 7 : 12"
              class="no-padding-sides"
              style="padding-top: 0"
            >
              <exercise-sets :exerciseSet="exerciseSet" />
            </v-col>
          </v-row>
          <!-- Exercise information -->
          <v-row>
            <v-col>
              <label class="title-label">Caractéristique de l'exercice</label>
              <v-container fluid>
                <v-row>
                  <!-- Exercise type -->
                  <div v-if="exerciseSet.exercise.exerciseType" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Type: </label>
                    <p>
                      {{ exerciseTypeItems.find((e) => e.value === exerciseSet.exercise.exerciseType).text }}
                    </p>
                  </div>
                  <!-- destination type -->
                  <div v-if="exerciseSet.exercise.destinationType" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Destination: </label>
                    <p v-if="exerciseSet.exercise.destinationType === DestinationTypes.DISCIPLINE">Spécifique</p>
                    <p v-else-if="exerciseSet.exercise.destinationType === DestinationTypes.PUBLIC">Transversal</p>
                    <p v-else>ERREUR</p>
                  </div>
                  <!-- description -->
                  <div v-if="exerciseSet.exercise.descriptionHtml" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Description</label>
                    <p v-html="exerciseSet.exercise.descriptionHtml" />
                  </div>
                  <!-- instructions -->
                  <div v-if="exerciseSet.exercise.instructionsHtml" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Consigne(s)</label>
                    <p v-html="exerciseSet.exercise.instructionsHtml" />
                  </div>
                  <!-- materiel -->
                  <div v-if="exerciseSet.exercise.materielHtml" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Matériel(s)</label>
                    <p v-html="exerciseSet.exercise.materielHtml" />
                  </div>
                  <!-- critere real -->
                  <div v-if="exerciseSet.exercise.realisation" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Critère de réalisation</label>
                    <p v-html="exerciseSet.exercise.realisation" />
                  </div>
                  <!-- prerequis -->
                  <div v-if="exerciseSet.exercise.prerequis" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Prérequis</label>
                    <p v-html="exerciseSet.exercise.prerequis" />
                  </div>
                  <!-- variables -->
                  <div v-if="exerciseSet.exercise.variables" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Variables</label>
                    <p v-html="exerciseSet.exercise.variables" />
                  </div>
                  <!-- experience lvl -->
                  <div v-show="exerciseSet.exercise.experienceLevels && exerciseSet.exercise.experienceLevels.length > 0" class="col-12 col-xl-6 container-chip-list">
                    <label class="font-weight-bold t-blue">{{ experienceLevelCustomTitle }}</label>
                    <v-row>
                      <v-col>
                        <v-chip v-for="experienceLevel in exerciseSet.exercise.experienceLevels" class="ma-2" :key="experienceLevel.id">
                          {{ experienceLevel.title }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- work forms -->
                  <div v-show="exerciseSet.exercise.workForms && exerciseSet.exercise.workForms.length > 0" class="col-12 col-xl-6 container-chip-list">
                    <label class="font-weight-bold t-blue">{{ workFormCustomTitle }}</label>
                    <v-row>
                      <v-col>
                        <v-chip v-for="workForm in exerciseSet.exercise.workForms" class="ma-2" :key="workForm.id">
                          {{ workForm.title }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- skills -->
                  <div
                    v-if="exerciseSet.exercise.advancedMode && exerciseSet.exercise.skills && exerciseSet.exercise.skills.length > 0"
                    class="col-12 col-xl-6 container-chip-list"
                  >
                    <label class="font-weight-bold t-blue">{{ skillCustomTitle }}</label>
                    <v-row>
                      <v-col>
                        <v-chip v-for="skill in exerciseSet.exercise.skills" class="ma-2" :key="skill.id">
                          {{ skill.title }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- info comp -->
                  <div v-if="exerciseSet.critéreRéussite" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Informations complémentaires</label>
                    <p v-html="exerciseSet.critéreRéussite" />
                  </div>
                  <!-- Observables -->
                  <div v-if="exerciseSet.exercisesSetObservables.length > 0" class="col-12 col-xl-6">
                    <label class="font-weight-bold t-blue">Observables</label>

                    <span>
                      {{ exerciseSet.exercisesSetObservables | joinObservable }}
                    </span>
                  </div>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <!-- medias -->
          <div class="row" v-if="exerciseSet.exercise.exerciseMedia.length > 0" style="padding-bottom: 2vh">
            <div class="col-12">
              <label class="title-label">Médias</label>
            </div>
            <div class="col col-lg-4 col-xl-2" v-for="media in medias" :key="media.id">
              <div
                class="card shadow card-media"
                @click="
                  dialog = true;
                  selected = media;
                "
              >
                <img class="img-fluid" :src="media.image" />
                <div class="card-body p-auto card-body-media">
                  <h5 class="card-title text-center my-auto card-title-media">{{ media.name }}</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- dialog -->
          <v-dialog v-model="dialog" max-width="70vw" style="max-height: 90vh !important">
            <v-card v-if="selected" class="mx-auto">
              <!-- Illustration -->
              <div style="width: 100%">
                <video-player
                  v-if="selected.typeId == 2 || selected.youtube"
                  :options="selected.videoOptions"
                  :key="selected.id"
                  style="width: 100%; height: auto; max-height: 100%"
                ></video-player>
                <v-img
                  v-else-if="selected.typeId == 1 || selected.isImage"
                  :src="selected.image || selected.url"
                  :contain="true"
                  style="width: 100%; height: auto; max-height: 100%"
                ></v-img>
                <iframe v-else-if="selected.typeId == 4 && selected.canal" :src="selected.src" style="width: 100%; height: auto; max-height: 100%"></iframe>
                <a v-else-if="selected.typeId == 4" :href="selected.src" target="_blank">
                  {{ selected.src }}
                </a>
              </div>
              <!-- Name -->
              <v-card-title>
                <v-label style="font-size: 16px; font-weight: bold; color: #506d88; padding: 5px 5px 5px 10px !important">{{ selected.name }}</v-label>
              </v-card-title>
              <!-- Download -->
              <v-card-actions>
                <v-form>
                  <v-btn v-if="selected.typeId == 3">
                    <a :href="selected.file">Télécharger</a>
                  </v-btn>
                </v-form>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer";
import ExerciseSets from "@/components/ExerciseSets";
import { getDownloadMediaByPathAsync } from "@/api/mediaApi";
import { getDisciplineAsync } from "@/api/disciplinesApi";
import { DestinationType } from "@/models/enums";
import { ExerciseType } from "@/models/enums";
import store from "@/store";

export default {
  name: "exercise",

  components: {
    ExerciseSets,
    VideoPlayer,
  },

  props: {
    exerciseSet: Object,
  },

  data() {
    return {
      open: 0,
      dialog: false,
      selected: null,
      medias: [],
      experienceLevelCustomTitle: "",
      workFormCustomTitle: "",
      exerciseSkills: [],
      skillCustomTitle: "",
      exerciseTypeItems: [
        { text: "Exercice", value: ExerciseType.EXERCISE },
        { text: "Test (évaluation)", value: ExerciseType.EVALUATION },
        { text: "Situation de référence", value: ExerciseType.REFERENCE },
      ],
      DestinationTypes: DestinationType,
    };
  },

  async mounted() {
    // Load the medias
    this.medias = await this.loadImage();

    // Empty only frontend experienceLevels property (used to handle ddl selected values)
    this.exerciseSet.exercise.experienceLevels = [];
    // Get all the many many exerciseExperienceLevels values and map only the experienceLevel id into experienceLevels (filling the ddl with values)
    this.exerciseSet.exercise.exerciseExperienceLevels.forEach((element) => {
      this.exerciseSet.exercise.experienceLevels.push(element.experienceLevel);
    });

    // Empty only frontend workForms property (used to handle ddl selected values)
    this.exerciseSet.exercise.workForms = [];
    // Get all the many many exerciseWorkForms values and map only the workForm id into workForms (filling the ddl with values)
    this.exerciseSet.exercise.exerciseWorkForms.forEach((element) => {
      this.exerciseSet.exercise.workForms.push(element.workForm);
    });

    // Empty only frontend skills property (used to handle ddl selected values)
    this.exerciseSet.exercise.skills = [];
    // Get all the many many exerciseSkills values and map only the workForm id into skills (filling the ddl with values)
    this.exerciseSet.exercise.exerciseSkills.forEach((element) => {
      this.exerciseSet.exercise.skills.push(element.skill);
    });

    // If there is a related discipline, get the custom labels
    if (this.exerciseSet.exercise && this.exerciseSet.exercise.disciplineId) {
      await this.getDisciplineForCustomLabels();
    }
  },

  filters: {
    joinObservable: function (observables) {
      return observables.map((item) => item.observable.name).join(", ");
    },
  },

  methods: {
    async loadImage() {
      let list = [];
      if (this.exerciseSet.exercise.exerciseMedia) {
        this.exerciseSet.exercise.exerciseMedia.forEach((e) => {
          list.push(e.media);
        });

        const toReturn = [];
        for (let i = 0; i < list.length; i++) {
          let url = list[i].url;
          if (url) {
            const urlCreator = window.URL || window.webkitURL;
            let response;
            let result;
            switch (list[i].typeId) {
              case 1:
                response = await getDownloadMediaByPathAsync(url);
                if(!response) break;
                result = await response.blob();
                list[i].image = urlCreator.createObjectURL(result);
                toReturn.push({
                  id: list[i].id,
                  src: urlCreator.createObjectURL(result),
                  alt: list[i].name,
                });
                break;
              case 2:
                response = await getDownloadMediaByPathAsync(url);
                if(!response) break;
                result = await response.blob();
                list[i].image = require("@/assets/Placeholder_video.jpg");
                list[i].videoOptions = {
                  techOrder: ["html5", "youtube"],
                  autoplay: false,
                  controls: true,
                  responsive: true,
                  sources: [
                    {
                      src: urlCreator.createObjectURL(result),
                      type: response.headers.get("Content-Type"),
                    },
                  ],
                };
                toReturn.push({
                  id: list[i].id,
                  src: require("@/assets/Placeholder_video.jpg"),
                  alt: list[i].name,
                });

                break;
              case 3:
                response = await getDownloadMediaByPathAsync(url);
                if(!response) break;
                result = await response.blob();
                list[i].image = require("@/assets/Placeholder_fichier.jpg");
                list[i].file = urlCreator.createObjectURL(result);
                toReturn.push({
                  id: list[i].id,
                  src: require("@/assets/Placeholder_fichier.jpg"),
                  alt: list[i].name,
                });
                break;
              case 4:
                list[i].image = require("@/assets/Placeholder_lien.jpg");
                const parse = require("url-parse");
                const parsed = parse(url, true);
                const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gim;
                const pictureRegex = /http[s]?:\/\/.+\.(jpeg|png|jpg|gif)/gim;
                list[i].src = url;
                if (parsed.hostname.includes("canal-sport") && parsed.pathname.endsWith("player")) list[i].canal = true;
                else if (youtubeRegex.exec(url)) {
                  list[i].youtube = true;
                  list[i].videoOptions = {
                    techOrder: ["html5", "youtube"],
                    autoplay: false,
                    controls: true,
                    responsive: true,
                    sources: [
                      {
                        src: url,
                        type: "video/youtube",
                      },
                    ],
                  };
                } else if (pictureRegex.exec(url)) {
                  list[i].isImage = true;
                  list[i].image = url;
                }

                toReturn.push({
                  id: list[i].id,
                  src: require("@/assets/Placeholder_lien.jpg"),
                  alt: list[i].name,
                });
                break;
              default:
                break;
            }
          }
        }
      }

      return list;
    },

    // Get the current discipline to use the custom Experience Level title and the workform custom title
    async getDisciplineForCustomLabels() {
      if (this.exerciseSet.exercise.disciplineId) {
        var currentDiscipline = await getDisciplineAsync(this.exerciseSet.exercise.disciplineId);

        if (!currentDiscipline) {
          store.dispatch("setSnackbar", {
            title: "Erreur",
            text: "Impossible de récupérer la discipline auprès du serveur",
            status: "error",
            timeout: 5000,
          });
        } else {
          // experience level
          this.experienceLevelCustomTitle = currentDiscipline.experienceLevelCustomTitle ? currentDiscipline.experienceLevelCustomTitle : "Niveaux de pratique";

          // workform
          this.workFormCustomTitle = currentDiscipline.workFormCustomTitle ? currentDiscipline.workFormCustomTitle : "Formes de travail";

          // skill
          this.skillCustomTitle = currentDiscipline.skillCustomTitle ? currentDiscipline.skillCustomTitle : "Compétences";
        }
      }
    },
  },
};
</script>

<style>
.exercise-icon {
  width: 30px;
  margin-right: 10px;
  flex: none !important;
}

.container-chip-list {
  padding-bottom: 10px;
}
</style>

<style lang="scss" scoped>
.card-media {
  height: 100%;
  cursor: pointer;
}
.card-body-media {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.5vh;
}
.card-title-media {
  display: flex;
  align-items: center;
}
.v-application p {
  margin-bottom: 0px;
}
</style>
